import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import registerBg from '../images/register-bg.png';
import NavbarComp from '../components/Navbar';
import { RegisterLogic } from "../utils/Registerlogic";

function Register() {
  const {
    formData,
    errors,
    handleChange,
    handleSubmit,
    statesAndDistricts,
    mother_tongue,
  } = RegisterLogic();
  const [loading, setLoading] = useState(false);
  return (
<div>
  <NavbarComp />
  <div
    className="d-flex align-items-center justify-content-center"
    style={{
      backgroundImage: `url(${registerBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight: "87vh",
    }}
  >
    <Container>
      <Row>
        <Col xs={12} sm={10} md={8} lg={6} xl={5}>
          <div
            className="shadow-lg"
            style={{
              backgroundColor: "#B0004E",
              borderRadius: "15px",
              overflow: "hidden",
            }}
            role="region"
            aria-labelledby="formHeading"
          >
            <div
              style={{
                backgroundColor: "#000",
                padding: "18px",
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",
                textAlign: "center",
              }}
            >
              <h5 className="text-white m-0" id="formHeading">
                Create your account to start your journey
              </h5>
            </div>

            <div className="p-4">
              <main role="main">
                <Form onSubmit={handleSubmit} aria-labelledby="formHeading">
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      name="full_name"
                      placeholder="Full Name"
                      value={formData.full_name}
                      onChange={handleChange}
                      isInvalid={!!errors.full_name}
                      required
                      className="py-1"
                      aria-label="Full Name"
                      aria-describedby="fullNameError"
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      id="fullNameError"
                      style={{ color: "#ffc107" }}
                      aria-live="assertive"
                    >
                      {errors.full_name}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                      isInvalid={!!errors.email}
                      required
                      className="py-1"
                      aria-label="Email Address"
                      aria-describedby="emailError"
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      id="emailError"
                      style={{ color: "#ffc107" }}
                      aria-live="assertive"
                    >
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Select
                          name="gender"
                          value={formData.gender}
                          onChange={handleChange}
                          isInvalid={!!errors.gender}
                          required
                          className="py-1"
                          aria-label="Gender"
                          aria-describedby="genderError"
                        >
                          <option value="">Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="other">Other</option>
                        </Form.Select>
                        <Form.Control.Feedback
                          type="invalid"
                          id="genderError"
                          style={{ color: "#ffc107" }}
                          aria-live="assertive"
                        >
                          {errors.gender}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Select
                          name="mother_tongue"
                          value={formData.mother_tongue}
                          onChange={handleChange}
                          required
                          aria-label="Mother Tongue"
                        >
                          <option value="">Mother Tongue</option>
                          {mother_tongue.map((lang) => (
                            <option key={lang} value={lang}>
                              {lang}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Select
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          required
                          className="py-1"
                          aria-label="State"
                        >
                          <option value="">State</option>
                          {Object.keys(statesAndDistricts).map((state) => (
                            <option key={state} value={state}>
                              {state}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Select
                          name="district"
                          value={formData.district}
                          onChange={handleChange}
                          required
                          disabled={!formData.state}
                          className="py-1"
                          aria-label="District"
                        >
                          <option value="">District</option>
                          {formData.state &&
                            statesAndDistricts[formData.state].map(
                              (district) => (
                                <option key={district} value={district}>
                                  {district}
                                </option>
                              )
                            )}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Select
                          name="user_type"
                          value={formData.user_type}
                          onChange={handleChange}
                          isInvalid={!!errors.user_type}
                          required
                          className="py-1"
                          aria-label="User Type"
                          aria-describedby="userTypeError"
                        >
                          <option value="">User Type</option>
                          <option value="user">User</option>
                          <option value="expert">Expert</option>
                        </Form.Select>
                        <Form.Control.Feedback
                          type="invalid"
                          id="userTypeError"
                          style={{ color: "#ffc107" }}
                          aria-live="assertive"
                        >
                          {errors.user_type}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          name="phone"
                          placeholder="Mobile Number"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          maxLength="10"
                          isInvalid={!!errors.phone}
                          className="py-1"
                          aria-label="Mobile Number"
                          aria-describedby="phoneError"
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          id="phoneError"
                          style={{ color: "#ffc107" }}
                          aria-live="assertive"
                        >
                          {errors.phone}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="password"
                          name="password"
                          placeholder="Password"
                          value={formData.password}
                          onChange={handleChange}
                          isInvalid={!!errors.password}
                          required
                          className="py-1"
                          aria-label="Password"
                          aria-describedby="passwordError"
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          id="passwordError"
                          style={{ color: "#ffc107" }}
                          aria-live="assertive"
                        >
                          {errors.password}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="password"
                          name="confirm_password"
                          placeholder="Confirm Password"
                          value={formData.confirm_password}
                          onChange={handleChange}
                          isInvalid={!!errors.confirm_password}
                          required
                          className="py-1"
                          aria-label="Confirm Password"
                          aria-describedby="confirmPasswordError"
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          id="confirmPasswordError"
                          style={{ color: "#ffc107" }}
                          aria-live="assertive"
                        >
                          {errors.confirm_password}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Button
                    variant="dark"
                    type="submit"
                    className="w-100 py-1 mt-2 fw-bold"
                    disabled={loading}
                    style={{ borderRadius: "8px" }}
                    aria-busy={loading}
                    aria-live="polite"
                  >
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Create New Account"
                    )}
                  </Button>

                  <p className="mt-3 text-white text-center">
                    Already have an account?{" "}
                    <Link
                      to="/login"
                      style={{
                        color: "lightblue",
                        textDecoration: "underline",
                      }}
                      aria-label="Sign in to your existing account"
                    >
                      Sign in
                    </Link>
                  </p>
                </Form>
              </main>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
  {/* FOOTER */}
        <footer className="login-footer">
          <Container>
            <div className="footer-text">
              © {new Date().getFullYear()}  Amrita CREATE | AI Video Accessibility Platform
            </div>
          </Container>
        </footer>
  


  <style>{`
   /* FOOTER */

        .login-footer {
          background: #ffffff;
          border-top: 1px solid #e5e5e5;
          padding: 12px 10px;
          flex-shrink: 0;
        }

        .footer-text {
          text-align: center;
          color: #4b5563;
          font-size: 14px;
          // letter-spacing: 0.3px;
          font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
        }
           @media (max-width: 480px) {

          .login-box {
            padding: 28px 20px;
          }

          .login-title {
            font-size: 2.2rem;
          }

          .signup-wrapper {
            flex-direction: row;
            flex-wrap: wrap;
          }

          .partner-logos img {
            height: 32px;
          }

          .main-logo img {
            height: 40px;
              cursor: pointer !important;

          }

          .footer-text {
            font-size: 0.82rem;
          }
        }
 @media (max-width: 768px) {

          // .login-box {
          //   padding: 32px 24px;
          //   margin: 10px auto;
          // }

          // .login-title {
          //   font-size: 2.5rem;
          // }

          .partner-logos {
            width: 100%;
            justify-content: center;
          }

          .main-logo {
            width: 100%;
            text-align: center;
  cursor: pointer !important;

          }
        }


      `}</style>
</div>


  );
};

export default Register;

// import React, { useState } from "react";
// import {
//   Form,
//   Button,
//   Container,
//   Row,
//   Col,
//   Spinner,
// } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import { RegisterLogic } from "../utils/Registerlogic";

// import registerBg from "../images/register-bg.png";

// import logo from "../images/cvv-nvbar.png";
// import meityLogo from "../images/meitylogo.png";
// import amritaLogo from "../images/amritalogo.png";
// import cdacLogo from "../images/cdac.png";

// function Register() {
//   const {
//     formData,
//     errors,
//     handleChange,
//     handleSubmit,
//     statesAndDistricts,
//     mother_tongue,
//     navigate,
//   } = RegisterLogic();

//   const [loading] = useState(false);

//   return (
//     <div className="register-page">
//       {/* HEADER */}
//       <header className="register-header">
// <Container fluid className="h-100">
//             <div className="header-wrapper">
//             {/* LEFT LOGO */}
//             <div
//               className="main-logo"
//               role="button"
//               tabIndex={0}
//               onClick={() => navigate("/")}
//               onKeyDown={(e) => {
//                 if (e.key === "Enter" || e.key === " ") navigate("/");
//               }}
//             >
//               <img src={logo} alt="CCV Logo" />
//             </div>

//             {/* RIGHT LOGOS */}
//             <div className="partner-logos">
//               <img src={meityLogo} alt="Meity" />
//               <img src={cdacLogo} alt="CDAC" />
//               <img src={amritaLogo} alt="Amrita" />
//             </div>
//           </div>
//         </Container>
//       </header>

//       {/* MAIN */}
//       <main
//         className="register-main"
//         style={{
//           backgroundImage: `url(${registerBg})`,
//         }}
//       >
//         <Container fluid>
//           {/* <Row className="justify-content-center justify-content-md-start"> */}
//           <Row className="justify-content-center justify-content-lg-start">
//             {/* <Col
//               xs={11}
//               sm={10}
//               md={8}
//               lg={6}
//               xl={5}
//               xxl={4}
//               className="register-box-wrapper"
//             > */}
//             <Col
//   xs={12}
//   sm={11}
//   md={9}
//   lg={6}
//   xl={5}
//   xxl={4}
//   className="register-box-wrapper"
// >
//               <div className="register-box">
//                 {/* TOP BLACK HEADER */}
//                 <div className="register-top">
//                   <h2>Create your account to start your journey</h2>
//                 </div>

//                 {/* FORM */}
//                 <div className="register-body">
//                   <Form onSubmit={handleSubmit}>
//                     {/* FULL NAME */}
//                     <Form.Group className="mb-3">
//                       <Form.Control
//                         type="text"
//                         name="full_name"
//                         placeholder="Full Name"
//                         value={formData.full_name}
//                         onChange={handleChange}
//                         isInvalid={!!errors.full_name}
//                         required
//                         className="custom-input"
//                       />
//                     </Form.Group>

//                     {/* EMAIL */}
//                     <Form.Group className="mb-3">
//                       <Form.Control
//                         type="email"
//                         name="email"
//                         placeholder="Email Address"
//                         value={formData.email}
//                         onChange={handleChange}
//                         isInvalid={!!errors.email}
//                         required
//                         className="custom-input"
//                       />
//                     </Form.Group>

//                     {/* GENDER + MOTHER TONGUE */}
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Select
//                             name="gender"
//                             value={formData.gender}
//                             onChange={handleChange}
//                             isInvalid={!!errors.gender}
//                             required
//                             className="custom-input"
//                           >
//                             <option value="">Gender</option>
//                             <option value="male">Male</option>
//                             <option value="female">Female</option>
//                             <option value="other">Other</option>
//                           </Form.Select>
//                         </Form.Group>
//                       </Col>

//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Select
//                             name="mother_tongue"
//                             value={formData.mother_tongue}
//                             onChange={handleChange}
//                             required
//                             className="custom-input"
//                           >
//                             <option value="">Mother Tongue</option>

//                             {mother_tongue.map((lang) => (
//                               <option key={lang} value={lang}>
//                                 {lang}
//                               </option>
//                             ))}
//                           </Form.Select>
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     {/* STATE + DISTRICT */}
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Select
//                             name="state"
//                             value={formData.state}
//                             onChange={handleChange}
//                             required
//                             className="custom-input"
//                           >
//                             <option value="">State</option>

//                             {Object.keys(statesAndDistricts).map((state) => (
//                               <option key={state} value={state}>
//                                 {state}
//                               </option>
//                             ))}
//                           </Form.Select>
//                         </Form.Group>
//                       </Col>

//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Select
//                             name="district"
//                             value={formData.district}
//                             onChange={handleChange}
//                             required
//                             disabled={!formData.state}
//                             className="custom-input"
//                           >
//                             <option value="">District</option>

//                             {formData.state &&
//                               statesAndDistricts[formData.state].map(
//                                 (district) => (
//                                   <option key={district} value={district}>
//                                     {district}
//                                   </option>
//                                 )
//                               )}
//                           </Form.Select>
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     {/* USER TYPE + PHONE */}
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Select
//                             name="user_type"
//                             value={formData.user_type}
//                             onChange={handleChange}
//                             isInvalid={!!errors.user_type}
//                             required
//                             className="custom-input"
//                           >
//                             <option value="">User Type</option>
//                             <option value="user">User</option>
//                             <option value="expert">Expert</option>
//                           </Form.Select>
//                         </Form.Group>
//                       </Col>

//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Control
//                             type="text"
//                             name="phone"
//                             placeholder="Mobile Number"
//                             value={formData.phone}
//                             onChange={handleChange}
//                             required
//                             maxLength="10"
//                             isInvalid={!!errors.phone}
//                             className="custom-input"
//                             aria-label="Mobile Number"
//                             aria-describedby="phoneError"

//                           />
//                            <Form.Control.Feedback
//                           type="invalid"
//                            id="phoneError"
//                            style={{ color: "#ffc107" }}
//                          aria-live="assertive"
//                         >
//                           {errors.phone}
//                          </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     {/* PASSWORD + CONFIRM PASSWORD */}
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Control
//                             type="password"
//                             name="password"
//                             placeholder="Password"
//                             value={formData.password}
//                             onChange={handleChange}
//                             isInvalid={!!errors.password}
//                             required
//                             className="custom-input"
//                             aria-label="Password"
//                          aria-describedby="passwordError"

//                           />
//                     <Form.Control.Feedback
//                           type="invalid"
//                            id="passwordError"
//                            style={{ color: "#ffc107" }}
//                            aria-live="assertive"
//                          >
//                            {errors.password}
//                          </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>

//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Control
//                             type="password"
//                             name="confirm_password"
//                             placeholder="Confirm Password"
//                             value={formData.confirm_password}
//                             onChange={handleChange}
//                             isInvalid={!!errors.confirm_password}
//                             required
//                             className="custom-input"
//                               aria-label="Confirm Password"
//                          aria-describedby="confirmPasswordError"
//                           />
//                                                 <Form.Control.Feedback
//                          type="invalid"
//                           id="confirmPasswordError"
//                          style={{ color: "#ffc107" }}
//                          aria-live="assertive"
//                         >
//                            {errors.confirm_password}
//                        </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     {/* BUTTON */}
//                     <Button
//                       variant="dark"
//                       type="submit"
//                       className="register-btn"
//                       disabled={loading}
//                     >
//                       {loading ? (
//                         <Spinner animation="border" size="sm" />
//                       ) : (
//                         "Create New Account"
//                       )}
//                     </Button>

//                     {/* SIGN IN */}
//                     <div className="signin-text">
//                       Already have an account?{" "}
//                       <Link to="/login">Sign in</Link>
//                     </div>
//                   </Form>
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </main>

//       {/* FOOTER */}
//       <footer className="register-footer">
//         <Container>
//           <div className="footer-text">
//             © {new Date().getFullYear()} Amrita CREATE | AI Video Accessibility
//             Platform
//           </div>
//         </Container>
//       </footer>

//       {/* CSS */}
//  <style>{`

// *{
//   margin:0;
//   padding:0;
//   box-sizing:border-box;
// }

// html,
// body,
// #root{
//   width:100%;
//   height:100%;
//   margin:0;
//   padding:0;
//   overflow:hidden;
//   font-family:"Segoe UI","Helvetica Neue",Arial,sans-serif;
// }

// html,
// body,
// #root{
//   width:100%;
//   height:100%;
//   margin:0;
//   padding:0;
//   font-family:"Segoe UI","Helvetica Neue",Arial,sans-serif;

//   /* HIDE SCROLLBAR */
//   overflow:hidden;

//   /* Firefox */
//   scrollbar-width:none;
// }

// /* Chrome Safari Edge */
// html::-webkit-scrollbar,
// body::-webkit-scrollbar{
//   display:none;
// }


// /* ========================= */
// /* PAGE */
// /* ========================= */

// .register-page{
//   height:100vh;
//   display:flex;
//   flex-direction:column;
//   overflow:hidden;
//   background:#fff;
// }
// /* ========================= */
// /* HEADER */
// /* ========================= */

// .register-header{
//   background:#fff;
//   border-bottom:1px solid #e5e7eb;
//   padding:10px 24px;
//   flex-shrink:0;
//   z-index:100;
// }

// .header-wrapper{
//   display:flex;
//   justify-content:space-between;
//   align-items:center;
//   gap:20px;
//   width:100%;
// }

// .main-logo{
//   cursor:pointer;
//   display:flex;
//   align-items:center;
// }

// .main-logo img{
//   height:40px;
//   width:auto;
//   object-fit:contain;
// }

// .partner-logos{
//   display:flex;
//   align-items:center;
//   gap:14px;
// }

// .partner-logos img{
//   height:40px;
//   width:auto;
//   object-fit:contain;
// }

// /* ========================= */
// /* MAIN */
// /* ========================= */

// // .register-main{
// //   flex:1;
// //   display:flex;
// //   align-items:center;
// //   justify-content:flex-start;
// //   background-size:cover;
// //   background-position:center;
// //   background-repeat:no-repeat;
// //   padding:24px 60px;
// // }

// .register-main{
//   flex:1;
//   display:flex;
//   align-items:center;
//   justify-content:flex-start;
//   background-size:cover;
//   background-position:center;
//   background-repeat:no-repeat;

//   /* IMPORTANT */
//   overflow:hidden;

//   padding:10px 50px;
// }

// /* ========================= */
// /* FORM POSITION */
// /* ========================= */

// .register-box-wrapper{
//   display:flex;
//   justify-content:flex-start;
//   align-items:center;
// }

// /* ========================= */
// /* REGISTER BOX */
// /* ========================= */

// // .register-box{
// //   width:100%;
// //   max-width:500px;
// //   background:#b0005a;
// //   border-radius:20px;
// //   overflow:hidden;
// //   box-shadow:0 10px 28px rgba(0,0,0,0.22);
// // }

// .register-box{
//   width:100%;
//   max-width:470px;
//   background:#b0005a;
//   border-radius:18px;
//   overflow:hidden;
//   box-shadow:0 8px 24px rgba(0,0,0,0.22);

//   /* IMPORTANT */
//   transform:scale(0.90);
//   transform-origin:left center;
// }

// /* ========================= */
// /* TOP */
// /* ========================= */

// .register-top{
//   background:#000;
//   padding:12px 16px;
//   text-align:center;
// }

// .register-top h2{
//   color:#fff;
//   font-size:1.1rem;
//   font-weight:400;
//   margin:0;
//   line-height:1.3;
// }

// /* ========================= */
// /* BODY */
// /* ========================= */

// .register-body{
//   padding:14px 18px;
// }
// /* ========================= */
// /* INPUTS */
// /* ========================= */

// .custom-input{
//   height:38px;
//   border:none !important;
//   box-shadow:none !important;
//   border-radius:6px !important;
//   background:#edf1f7 !important;
//   padding-left:12px !important;
//   font-size:0.92rem;
//   color:#222;
// }
// .custom-input:focus{
//   box-shadow:none !important;
// }

// .custom-input::placeholder{
//   color:#666;
// }

// .form-select.custom-input{
//   cursor:pointer;
// }

// /* ========================= */
// /* BUTTON */
// /* ========================= */

// .register-btn{
//   width:100%;
//   height:40px;
//   border:none !important;
//   background:#1f2733 !important;
//   border-radius:8px;
//   font-size:0.95rem;
//   font-weight:700;
//   margin-top:4px;
// }

// .register-btn:hover{
//   background:#111827 !important;
// }

// /* ========================= */
// /* SIGN IN */
// /* ========================= */

// .signin-text{
//   margin-top:10px;
//   text-align:center;
//   color:#fff;
//   font-size:0.9rem;
// }

// .signin-text a{
//   color:#dbeafe;
//   font-weight:500;
// }

// /* ========================= */
// /* FOOTER */
// /* ========================= */

// .register-footer{
//   background:#fff;
//   border-top:1px solid #e5e7eb;
//   padding:10px;
//   flex-shrink:0;
// }

// .footer-text{
//   text-align:center;
//   font-size:13px;
//   color:#4b5563;
//   font-weight:500;
// }

// /* ========================= */
// /* LARGE DESKTOP */
// /* ========================= */

// @media (min-width:1400px){

//   .register-main{
//     padding-left:90px;
//   }

//   .register-box{
//     max-width:520px;
//   }
// }

// /* ========================= */
// /* LAPTOP */
// /* ========================= */

// // @media (max-width:1200px){

// //   .register-main{
// //     padding:20px 32px;
// //   }

// //   .register-box{
// //     max-width:470px;
// //   }

// //   .register-top h2{
// //     font-size:1.3rem;
// //   }

// //   .custom-input{
// //     height:42px;
// //   }

// //   .register-body{
// //     padding:18px 20px;
// //   }
// // }
// @media (max-width:1200px){

//   .register-main{
//     padding:12px 28px;
//     align-items:center;
//   }

//   .register-box{
//     max-width:460px;
//     transform:scale(0.92);
//   }

//   .register-top h2{
//     font-size:1.2rem;
//   }

//   .register-body{
//     padding:16px 18px;
//   }

//   .custom-input{
//     height:40px;
//     font-size:0.92rem;
//   }

//   .register-btn{
//     height:42px;
//   }

//   .signin-text{
//     margin-top:10px;
//     font-size:0.9rem;
//   }
// }
// /* ========================= */
// /* TABLET */
// /* ========================= */

// // @media (max-width:992px){

// //   html,
// //   body,
// //   #root{
// //     overflow:auto;
// //   }

// //   .register-page{
// //     overflow:auto;
// //   }

// //   .register-main{
// //     justify-content:center;
// //     align-items:flex-start;
// //     padding:24px 18px;
// //   }

// //   .register-box-wrapper{
// //     justify-content:center;
// //   }

// //   .register-box{
// //     max-width:100%;
// //   }

// //   .header-wrapper{
// //     flex-direction:column;
// //     justify-content:center;
// //     gap:10px;
// //   }

// //   .main-logo{
// //     justify-content:center;
// //   }

// //   .partner-logos{
// //     justify-content:center;
// //     flex-wrap:wrap;
// //   }

// //   .register-top h2{
// //     font-size:1.2rem;
// //   }
// // }
// @media (max-width:992px){

//   html,
//   body,
//   #root{
//     overflow:auto;
//   }

//   .register-page{
//     overflow:auto;
//   }

//   .register-main{
//     justify-content:center;
//     align-items:center;
//     padding:18px 16px;
//   }

//   .register-box-wrapper{
//     justify-content:center;
//   }

//   .register-box{
//     max-width:100%;
//     transform:scale(1);
//   }

//   .header-wrapper{
//     flex-direction:column;
//     justify-content:center;
//     gap:10px;
//   }

//   .main-logo{
//     justify-content:center;
//   }

//   .partner-logos{
//     justify-content:center;
//     flex-wrap:wrap;
//   }

//   .register-top h2{
//     font-size:1.1rem;
//   }
// }
// /* ========================= */
// /* MOBILE */
// /* ========================= */
// @media (max-width:768px){

//   html,
//   body,
//   #root{
//     overflow:auto;
//   }

//   .register-page{
//     height:auto;
//     overflow-y:auto;

//     /* HIDE MOBILE SCROLLBAR */
//     scrollbar-width:none;
//   }

//   .register-page::-webkit-scrollbar{
//     display:none;
//   }

//   .register-main{
//     overflow:visible;
//     justify-content:center;
//     align-items:flex-start;
//     padding:16px 12px 24px;
//   }

//   .register-box{
//     max-width:100%;
//     transform:scale(1);
//   }

//   .register-box-wrapper{
//     justify-content:center;
//   }

//   .header-wrapper{
//     flex-direction:column;
//     gap:10px;
//   }

//   .main-logo{
//     justify-content:center;
//     width:100%;
//   }

//   .partner-logos{
//     justify-content:center;
//     flex-wrap:wrap;
//     width:100%;
//     gap:8px;
//   }

//   .main-logo img{
//     height:38px;
//   }

//   .partner-logos img{
//     height:28px;
//   }

//   .register-top h2{
//     font-size:1rem;
//   }

//   .footer-text{
//     font-size:11px;
//   }
// }
// @media (max-width:576px){

//   html,
//   body,
//   #root{
//     overflow:auto;
//   }

//   // .register-page{
//   //   overflow:auto;
//   // }
// .register-page{
//   height:100vh;
//   overflow:hidden;
// }
//   .register-header{
//     padding:10px 12px;
//   }

//   .main-logo{
//     width:100%;
//     justify-content:center;
//   }

//   .main-logo img{
//     height:40px;
//   }

//   .partner-logos{
//     width:100%;
//     justify-content:center;
//     flex-wrap:wrap;
//     gap:8px;
//   }

//   .partner-logos img{
//     height:28px;
//   }

//   .register-main{
//     padding:16px 12px 24px;
//     justify-content:center;
//     align-items:flex-start;
//   }

//   .register-box{
//     border-radius:16px;
//   }

//   .register-top{
//     padding:14px;
//   }

//   .register-top h2{
//     font-size:1.05rem;
//   }

//   .register-body{
//     padding:16px;
//   }

//   .custom-input{
//     height:42px;
//     font-size:0.92rem;
//   }

//   .register-btn{
//     height:44px;
//     font-size:0.95rem;
//   }

//   .signin-text{
//     font-size:0.9rem;
//   }

//   .footer-text{
//     font-size:11px;
//   }
// }

// `}</style>
//     </div>
//   );
// }

// export default Register;
